import { PaginateList } from '../../../common/types/common-types';

export enum CriteriaTypeEnum {
  NUMBER = 'NUMBER',
  PERCENTAGE = 'PERCENTAGE',
}

export type CriteriaListItem = {
  _id: string;
  name: string;
  type: CriteriaTypeEnum;
  isExistParameter?: boolean;
  createdBy: string;
  updatedBy: string;
  createdAt: Date;
  updatedAt: Date;
};

export type CriteriaPaginateList = PaginateList<CriteriaListItem> & {
  totalRecords: number;
};

export type CriteriaResultListParam = {
  name?: string;
  type?: string;
  isGetAll?: boolean;
  limit?: number;
  page?: number;
};

export enum CriteriaFormMode {
  CREATE = 'create',
  EDIT = 'edit',
}
